import React from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import classNames from 'classnames';
import _ from 'lodash';

import '../../../../node_modules/weather-icons-lite/css/weather-icons-lite.min.css';

import Icon from '@material-ui/core/Icon';

import * as weatherActions from '../../../actions/weatherActions';

import thermometer from '../../../assets/images/thermometre.png';

class Weather extends React.Component {
    constructor(props) {
        super(props);

        this.interval = null;
    }

    componentDidMount() {
        if (this.props.cityId) {
            this.getWeather();
            this.interval = setInterval(
                () => this.getWeather(),
                900000
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.cityId && this.props.cityId) {
            this.getWeather();
            this.interval = setInterval(
                () => this.getWeather(),
                900000
            );
        } else if (prevProps.cityId && !this.props.cityId) {
            clearInterval(this.interval);
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    getUnits(units) {
        // todo: use once weather module is expanded
        // if (units === 'metric') {
        //     return 'C';
        // } else if (units === 'imperial') {
        //     return 'F';
        // } else {
        //     return 'K';
        // }
        return 'C';
    }

    getWeather() {
        this.props.weatherActions.getWeatherByCityId(this.props.cityId, this.props.units);
    }

    render() {
        const temp = _.get(this.props.weather, 'data.main.temp');
        const units = this.getUnits(this.props.units);
        const weatherIcon = _.get(this.props.weather, 'data.weather[0].icon', '');
        const weatherClassnames = classNames({
            wi: true,
            [`wi-owm-${weatherIcon}`]: !!weatherIcon
        });

        if (temp === undefined) {
            return null;
        } else {
            return (
                <div className="weather">
                    <img src={thermometer} className="thermometre" alt="Thermometre"/>
                    <span>
                        {Math.round(temp)}
                        &deg;{units}
                    </span>
                    <Icon className={weatherClassnames}/>
                </div>
            );
        }
    }
}

Weather.propTypes = {
    cityId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    units: PropTypes.string,
    weather: PropTypes.object,
    weatherActions: PropTypes.objectOf(PropTypes.func)
};

function mapStateToProps(state) {
    return {
        cityId: _.get(state, 'firebase.data.office.config.weatherCityId', ''),
        units: _.get(state, 'firebase.data.office.config.weatherTempUnits', 'metric'),
        weather: state.weather
    };
}

function mapDispatchToProps(dispatch) {
    return {
        weatherActions: bindActionCreators(weatherActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Weather);


// WEBPACK FOOTER //
// ./src/components/dashboard/header/Weather.js